<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M14.25 14.25H1.75V9.31055L5.5 5.56055L8.5 8.56055L14.25 2.81055V14.25Z"
    stroke="currentColor"
    stroke-width="1.5"
  />
</svg>
